<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <v-row>
        <v-col md="12">
          <ModuleHeader>Cambiar plan de membresias </ModuleHeader>
        </v-col>
        <v-col md="12">
          Seleccione un plan de membresia, a continuacion se listaran todas las membresias con ese plan
        </v-col>
        <v-col md="6" cols="12" class="text-right">
          <v-autocomplete v-model="planSelected" @change="listMembresias()" :items="Catalogos.PlanesMembresias"
            item-text="Nomb" item-value="Id" label="Mover todas las membresias del plan:"></v-autocomplete>
          <!-- <download-excel class="exportExcel"  type="xls" name="Membresias.xls" :data="excelData">
          </download-excel> -->
        </v-col>
        <v-col v-if="false" md="6" cols="12" class="text-right">
          <v-autocomplete label="Nuevo plan:"></v-autocomplete>
          <!-- <download-excel class="exportExcel"  type="xls" name="Membresias.xls" :data="excelData">
          </download-excel> -->
        </v-col>
        <v-col md="12" cols="12" class="mb-10">
          <v-simple-table>
            <thead>
              <tr>
                <td>Membresia</td>
                <td>Titular</td>
                <td>Deuda</td>
              </tr>
            </thead>
            <tbody>
              <template v-for="(membresia, index) in Catalogos.data_membresias">
                <tr :key="index">
                  <td>{{ membresia.Code.Pre }}{{ membresia.Code.Pos }}</td>
                  <td>{{ membresia.Code.Pre }}{{ membresia.Code.Pos }}</td>
                  <td>{{ membresia.TitularName }} </td>
                  <td>{{ $pgsHelper.formatNumber(membresia.Deuda.C) }} {{ membresia.Deuda.M }}</td>
                </tr>
              </template>
              <tr></tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>

    </div>
    <div style="
            position: fixed !important;
            bottom: 0 !important;
            margin-left: -12px !important;
            width: 100% !important;
          ">
      <v-card elevation="4">
        <v-row>
          <v-col md="6" cols="12" class="px-4"><v-autocomplete @change="listMembresias()"
              :items="Catalogos.PlanesMembresias" item-text="Nomb" item-value="Id"
              label="Nueva membresia:"></v-autocomplete></v-col>
          <v-col md="6" cols="12"><v-btn color="success" block>Migrar</v-btn></v-col>
        </v-row>
      </v-card>
    </div>

  </div>
</template>



<script>
//import modal from "../../MainComponents/modal.vue";

import Membresia from "../../../clases/Membresias/Membresia.js";
import MembresiaPlan from "../../../clases/Membresias/MembresiaPlan.js";
import PeriodosCobro from "../../../clases/Membresias/PeriodosCobro.js";
import GenericExcelExporter from "../../../clases/ExcelMaker/GeneralExcel.js";
export default {
  name: "MembresiasCRUD",
  components: {
  },
  data() {
    return {
      formIndex: 0,
      selectedPlan: "",
      editMode: false,
      editData: {},
      indexComponent: 1,
      Dialogs: {
        sync: false,
        showModal: false,
      },
      Catalogos: {
        PlanesMembresias: [],
        data_membresias: [],
      },
      aux: {
        membresiaToSync: {},
      },

    };
  },
  computed: {
    clients() {
      let clientes = {};
      let rowclientes = this.$store.getters.getClientes;
      rowclientes.forEach((element) => {
        if (element.id != "PUBLICOGENERAL") {
          clientes[element.id] = element;
        }
      });
      return clientes;
    },
    /*dataMembresias(){
      let dataValidMem = [];
      let data_membresias =  Membresia.getMembresiasList();
      data_membresias.forEach((element)=>{
        element.code            = element?.Code?.Pre+''+element?.Code?.Pos
        element.NumeroMembresia = element?.Code?.Pos;
        element.PlanName        = this.$pgsHelper.getById(this.PlanesMembresias,'Id',element.Plan).Nomb;
        element.TitularName     = (this.clients[element.Titular])?
                                  this.clients[element.Titular].Nombres +
                                  " " +this.clients[element.Titular].Apellidos+
                                  ((this.clients[element.Titular].Apodo && this.clients[element.Titular].Apodo != '')?' ('+this.clients[element.Titular].Apodo+')':'')
                                  :'Sin titular';
        element.NombrePeriodo   = PeriodosCobro.getById(element.Periodo).Nombre
        element.Apodo = this.clients[element.Titular]?.Apodo
        if(!element.Dlat){
          dataValidMem.push(element);
        }
      })
      return dataValidMem;
    },*/
    excelData() {
      let data = [];
      this.dataMembresias.forEach((m) => {
        data.push({
          NumeroMembresia: m.code,
          Alias: m?.Apodo,
          Codigo: m?.Code?.Pos,
          Plan: m.PlanName,
          Titular: m.TitularName,
          Periodo: m.NombrePeriodo,
          Estatus: (m.Activo) ? 'ACTIVO' : 'INANCITVO',
          Deuda: parseFloat(m.Deuda.C).toFixed(2),
          Moneda: m.Deuda.M,
          Miembros: Object.keys(m.Clientes).length
        });
      })
      return data;
    },
    PlanesMembresias() {
      let PlanesMembresias = MembresiaPlan.getMembresiasPlanList();
      return PlanesMembresias;
    }
  },
  methods: {
    listMembresias() {
      let data_membresias = Membresia.getMembresiasList();
      let membresias = this.$pgsHelper.filterBy(data_membresias, "Plan", this.planSelected)
      membresias.forEach((membresia) => {
        membresia.TitularName = (this.clients[membresia.Titular]) ?
          this.clients[membresia.Titular].Nombres +
          " " + this.clients[membresia.Titular].Apellidos +
          ((this.clients[membresia.Titular].Apodo && this.clients[membresia.Titular].Apodo != '') ? ' (' + this.clients[membresia.Titular].Apodo + ')' : '')
          : 'Sin titular';
      })
      this.Catalogos.data_membresias = membresias
    },
    exportExcel() {
      GenericExcelExporter.generateExcelBuffer(this.excelData)
        .then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = "Membresias.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error("Error exportando:", error));
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createMembresia(data);
      } else if (doAction == "EDIT") {
        this.editarMembresia(data);
      }
    },

    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    syncBiometric() {
      this.aux.membresiaToSync;
      this.Dialogs.sync = false;
    },
    createMembresia(data) {
      console.log(data);
      data.DiasProrroga = Number(data.DiasProrroga);
      this.$swal({
        title: "¿Deseas guardar la membresia?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("MBS-Membresias-createMembresia", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "La membresia se guardo correctamente",
              icon: "success",
            }).then(async () => {
              //this.Dialogs.sync = true;
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving membresia",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editarMembresia(data) {
      this.$swal({
        title: "¿Deseas guardar la información de membresia?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("MBS-Membresias-updateMembresia", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El plan de membresia se guardo correctamente",
              icon: "success",
            }).then(async () => {
              //this.Dialogs.sync = true;
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving plan membresia",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    softDeleteMembresias(id) {
      let datos = { Id: id };
      this.$swal({
        title: "¿Deseas desactivar la membresia?",
        text: "Se eliminaran los clientes y titular de la memebresia selecionada",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("MBS-Membresias-deleteMembresia", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then(async (result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal("El plan de membresia se elimino correctamente", "", "success");
            //this.Catalogos.data_membresias = await Membresia.getMembresiasList();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.Dialogs.showModal = open;
    },
  },
  beforeMount: function () { },
  mounted: async function () {
    /*this.Catalogos.data_membresias = await Membresia.getMembresiasList();
    this.Catalogos.data_membresias.forEach((element)=>{
      element.NumeroMembresia = element?.Code?.Pos;
      element.TitularName = this.$pgsHelper.getById(this.comp_clients,'id',element.Titular);
    })*/
    this.Catalogos.PlanesMembresias = await MembresiaPlan.getMembresiasPlanList();
  },
};
</script>
<style scoped>
.exportExcel {
  width: fit-content !important;
  position: absolute !important;
  right: 10px;
}
</style>
